import { ILanguage } from "src/constants/locale";
import { formatRangeSliderNumber } from "src/hooks/formatters/number-formatter";

export const getNumberFromInputString = (value: string, thousandSeparator: string) =>
    Number.parseFloat(value.replaceAll(thousandSeparator, "").replace(",", "."));

export const getInputValueFromRange = (language: ILanguage, rangeValue: number, steps: number[], showPositiveLeadingSign: boolean) =>
    formatRangeSliderNumber({ language, value: steps[rangeValue], showPositiveLeadingSign });

export const getRangeIndexFromInput = (inputValue: number, steps: number[]) => {
    const closestStep = steps.reduce((a, b) => (Math.abs(b - inputValue) < Math.abs(a - inputValue) ? b : a), steps[0]);
    return steps.indexOf(closestStep);
};

const numberInputRegex = /^[-+]?[0-9.,]*$/;
export const isInputValid = (value: string) => numberInputRegex.test(value);

export const shouldNegateInputNumber = (currentInputValue: number, defaultMaxInputValue: number) =>
    !Number.isNaN(currentInputValue) && defaultMaxInputValue <= 0 && currentInputValue > 0;
